import { useEffect, useState } from 'react';
import i18next from 'i18next';
import vopayApi from '@/services/api.config';
import { useClientData } from '@/providers/ClientData.provider';

const { api } = vopayApi;

export default function useTranslationsOverride() {
  // this is to prevent a flash of the default translations from showing
  const [translationsInitialized, setTranslationsInitialized] = useState(false);

  const {
    response: { JWT },
  } = useClientData();

  useEffect(() => {
    changeLanguage(i18next.language);
  }, [i18next.language, JWT]);

  async function changeLanguage(lang: string) {
    await overrideTranslations(lang);
    i18next.changeLanguage(lang);
  }

  async function overrideTranslations(lang: string) {
    try {
      const urlRes = await api.fetchAccountTranslationsUrl({
        Product: 'portal',
        Language: lang,
      });

      if (!urlRes.Success) {
        throw new Error(urlRes.ErrorMessage);
      }

      revertTranslations(lang);

      // no overrides
      if (!urlRes.Url) {
        return;
      }

      const translationsRes = await fetch(urlRes.Url);
      const json = await translationsRes.json();
      i18next.addResourceBundle(lang, 'translations', json, true, true);
    } catch (err) {
      console.error(err);
    } finally {
      // allow use of the app, even if there were errors in setting language
      setTranslationsInitialized(true);
    }
  }

  function revertTranslations(lang: string) {
    i18next.removeResourceBundle(lang, 'translations');

    i18next.addResourceBundle(
      lang,
      'translations',
      JSON.parse(JSON.stringify(i18next.getResourceBundle(lang, 'originalTranslations'))),
      true,
      true,
    );
  }

  return {
    translationsInitialized,
    changeLanguage,
  };
}
